module.exports = __webpack_public_path__ + "img/archivo.4611a1a9.png";